// import React from "react";
import { useState } from "react";
import InnerHero from "../components/InnerHero";
import productsData from "../data/products";
import ProductModal from "../components/ProductCard";
import UsageSafety from "../components/UsageSafety";
import CTASection from "../components/CTASection";

function NPKFertilizer() {
    const [selectedProduct, setSelectedProduct] = useState(null);

    // 🔹 SIRF INSECTICIDE PRODUCTS
    const insecticideProducts = productsData.filter(
        product => product.category === "NPK Fertilizer"
    );
    return (
        <>
            <InnerHero
                title="NPK Fertilizers"
                subtitle="Balanced nutrition solutions providing essential Nitrogen, Phosphorus, and Potassium for healthy crop growth and higher yields."
                breadcrumb="Home / Products"
                bgImage="/images/img/npk.jpg"
            />

            <section className="category-intro-section">
                <div className="container">
                    <div className="row align-items-center">

                        {/* LEFT CONTENT */}
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="category-intro-content">
                                <h6 className="section-subtitle">CATEGORY OVERVIEW</h6>
                                <h2>
                                    Balanced <span>NPK Nutrition</span> for Strong Crop Growth
                                </h2>

                                <p>
                                    NPK Fertilizers are essential for providing plants with
                                    the three primary nutrients—Nitrogen (N), Phosphorus (P),
                                    and Potassium (K)—required for healthy growth and
                                    development. These nutrients support root formation,
                                    vegetative growth, and overall plant strength.
                                </p>

                                <p>
                                    Goodweel Crop Care offers a scientifically balanced range
                                    of NPK fertilizers designed to meet the nutritional
                                    demands of crops at different growth stages. Our
                                    formulations ensure efficient nutrient absorption and
                                    improved soil fertility.
                                </p>

                                <p>
                                    With consistent nutrient supply and easy application,
                                    our NPK solutions help farmers achieve vigorous plant
                                    growth, higher yields, and improved crop quality across
                                    various farming conditions.
                                </p>
                            </div>
                        </div>

                        {/* RIGHT IMAGE */}
                        <div className="col-lg-6">
                            <div className="category-intro-image">
                                <img
                                    src="/images/img/npk.jpg"
                                    alt="NPK Fertilizer"
                                    className="img-fluid"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* SECTION HEADING */}
            <div className="container text-center my-5">
                <h2 className="section-title">
                    Our <span>NPK Fertilizer Products</span>
                </h2>
                <p className="section-desc">
                    Explore our range of NPK fertilizers formulated to deliver
                    balanced nutrition, promote healthy crop growth, and
                    maximize yield potential.
                </p>
            </div>

            {/* PRODUCTS GRID (CSS SAME AS PRODUCT PAGE) */}
            <div className="container">
                <div className="row">
                    {insecticideProducts.map(product => (
                        <div
                            className="col-lg-3 col-md-4 col-sm-6 mb-4 Product-col"
                            key={product.id}
                        >
                            <div
                                className="product-card"
                                onClick={() => setSelectedProduct(product)}
                            >
                                <img
                                    src={product.image}
                                    alt={product.name}
                                />
                                <div className="product-overlay">
                                    <h6>{product.name}</h6>
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* SAFETY CHECK */}
                    {insecticideProducts.length === 0 && (
                        <p className="text-center mt-4">
                            No plant growth regulator products available at the moment.
                        </p>
                    )}
                </div>
            </div>

            {/* PRODUCT DETAILS MODAL (UNCHANGED) */}
            {selectedProduct && (
                <ProductModal
                    product={selectedProduct}
                    close={() => setSelectedProduct(null)}
                />
            )}
            <UsageSafety />
            <CTASection />

        </>
    );
};

export default NPKFertilizer;
